import React from 'react';
import { XIcon } from 'lucide-react';
import { painPoints } from '../data/content';
export function ProblemSection() {
  return <section className="w-full bg-ink-900 px-4 py-10 sm:px-6 sm:py-14" data-id="element-150" data-mp="2ltmm25fs8dre">
      <div className="mx-auto max-w-4xl text-center" data-id="element-151" data-mp="30hhcff6bi61b">
        <h2 className="text-xl font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-152" data-mp="30jahwr572k7q">
          ¿Cuántos meses más vas a cargar esa mochila de cemento?
        </h2>

        <p className="mx-auto mt-3 max-w-2xl text-[13px] leading-relaxed text-neutral-400 sm:text-base" data-id="element-153" data-mp="39gb6axs9kib6">
          Tenés el local. Tenés la mercadería. Tenés ganas de vender. Pero hay
          stock parado que no se mueve, redes que nadie mira y clientes que dicen
          "vuelvo" y no vuelven nunca.
        </p>

        <ul className="mt-6 grid gap-2.5 text-left sm:grid-cols-2" data-id="element-154" data-mp="3eew4ysrvatxi">
          {painPoints.map(point => <li key={point} className="flex items-start gap-3 rounded-xl border border-red-900/60 bg-blood-900 p-4" data-id="element-155" data-mp="1p3vofxc72ahd">
              <XIcon aria-hidden="true" strokeWidth={4} className="mt-0.5 h-4 w-4 shrink-0 text-blood-500" data-id="element-156" data-mp="jeeomg1zv5eu" />
              <span className="text-[13px] leading-relaxed text-neutral-300" data-id="element-157" data-mp="sd9wdwkosnk9">
                {point}
              </span>
            </li>)}
        </ul>

        <p className="mx-auto mt-6 max-w-2xl text-base font-extrabold leading-snug text-gold-400 sm:text-lg" data-id="element-158" data-mp="x6ctufsl4h5q">
          ¿Y si esta semana podés convertir ese stock clavado en efectivo con
          textos que ya vienen listos para copiar y pegar?
        </p>
      </div>
    </section>;
}